import { Configuration } from './generated/runtime';

export const httpConfiguration = new Configuration({
	basePath: `${window.origin}/io/configurations`,
	headers: { 'X-BFF-CSRF': 'true' },
});

export function configureHttp(configure: (current: Configuration) => void) {
	configure(httpConfiguration);
}
